import * as React from "react";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import HLApp from "../components/HL/Main/HLApp";
import muiTheme from "./Theme";
// import TLogin from "../components/common/TLogin";

class Root extends React.Component {
    state = {
        access: false,
    };

    onHandleLogin = ({ userName, password }, successFn, errorFn) => {
        if (password === "test0226") {
            this.setState(
                {
                    access: true,
                },
                () => {
                    successFn(true);
                }
            );
        } else {
            successFn(false);
        }
    };

    render() {
        // if (this.state.access) {
        return (
            <MuiThemeProvider theme={muiTheme}>
                <HLApp />
            </MuiThemeProvider>
        );
        // }
        // else {
        //     return (
        //         <TLogin onHandleLogin={this.onHandleLogin} />
        //     );
        // }
    }
}

export default Root;
